module.exports = __webpack_public_path__ + "static/media/Background4.96560c41.png";